// extracted by mini-css-extract-plugin
export default {"footerDivider":"FooterDivider_footerDivider__irRar"};